<template>
  <div id="options-control">
    <div class="options-wrapper-title">
      <h2 class="options-title">Options</h2>
      <MobileOptionsControl />
    </div>
    <p v-if="enableMobileOptions" class="description">Mobile-specific data-options.</p>
    <ExamplesControl v-show="!enableMobileOptions" />
    <OptionsList v-show="!enableMobileOptions" />
    <MobileOptionsList v-show="enableMobileOptions" />
  </div>
</template>
<script>
import ExamplesControl from "@/widgets/common/ExamplesControl";
import MobileOptionsControl from "@/widgets/controls/MobileOptionsControl";
import MobileOptionsList from "@/widgets/controls/MobileOptionsList";
import OptionsList from "@/widgets/controls/OptionsList";
import { mapState } from "vuex";
import { mobileMixin } from "@/mixins/mobile.mixin";

export default {
  name: "OptionsControl",
  components: {
    ExamplesControl,
    MobileOptionsControl,
    MobileOptionsList,
    OptionsList,
  },
  mixins: [mobileMixin],
  computed: {
    ...mapState(["enableMobileOptions"]),
  },
};
</script>
<style lang="scss">
#options-control {
  box-shadow: 0 8px 40px rgba(50, 123, 186, 0.16), 0 4px 4px rgba(50, 123, 186, 0.08);
  padding: 20px;
  background-color: #fff;
  border-radius: 8px;
  margin: 0 0 20px;
  width: 100%;

  .el-collapse-item__header {
    font-size: 16px;
    color: #6c7683;
    font-weight: bold;
  }

  .el-collapse-item__content {
    max-width: 360px;
  }

  @media only screen and (min-width: 992px) {
    margin: 0 20px 0;
    flex: 0 0 400px;
  }
}
.el-collapse {
  border-bottom: none !important;
}
.collapsed {
  &.without-top-b {
    border-top: 0;
    & > .el-collapse-item {
      & > .el-collapse-item__wrap {
        border-bottom: 0;
      }
    }

    .el-collapse-item:nth-last-child {
      .el-collapse-item__wrap {
        border-bottom: 1px solid #ebeef5;
      }
    }

    .control {
      max-width: 340px;
    }
  }
}
.codecssstyle {
  //line-height: 1.8;
  //display: block;
  //margin: 10px 0;
}
.el-radio {
  margin-right: 25px;
}

h2.options-title {
  color: #2f363f;
  margin: 10px 0;
}
.indent {
  margin-left: 20px;
}
.control {
  display: flex;
  flex-direction: column;
  margin-bottom: 5px;

  &__title {
    // color: #2f363f;
    color: #6c7683;
    margin-left: 15px;
  }

  &.example {
    display: flex;
    flex-direction: row;
    align-items: center;
    margin-bottom: 15px;

    .control__title {
      display: inline-block;
      margin-right: 10px;
      margin-left: 0;
      font-weight: bold;
      color: #6c7683;
    }
    .control__action {
      width: 100%;
      padding: 0;
    }
  }

  .title {
    position: relative;
    display: flex;
    width: 100%;
  }

  .title-text {
    display: block;
    white-space: nowrap;
  }

  &__trigger {
    width: 20px;
    height: 20px;
  }

  &__helper {
    margin-left: 5px;
    position: relative;
    max-width: 100%;
    cursor: pointer;
    min-width: 250px;
    display: none;
    img {
      width: 12px;
      height: 12px;
    }
    .hint {
      z-index: 9999;
      position: absolute;
      left: 20px;
      top: 1px;
      background-color: rgba(0, 0, 0, 1);
      color: white;
      padding: 2px 10px;
      border-radius: 8px;
      max-width: 230px;
    }
  }
  @media only screen and (min-width: 480px) {
    &__helper {
      display: block;
    }
  }
  &__action {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding-right: 7px;
  }

  &__choice {
    max-width: 100%;
    width: 100%;
    position: relative;
    margin-left: 15px;
  }

  &__checkbox {
    margin-left: 10px;
  }

  &__select {
    width: 100%;
  }

  &__aditional {
    margin-top: 10px;
  }
}
.fakeoverlay {
  position: relative;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  z-index: 1;
  display: block;
}
.disabled {
  width: 100%;
  position: absolute;
  cursor: not-allowed;
  z-index: 3;
}
.disabledStatus {
  position: absolute;
  cursor: not-allowed;
  z-index: 3;
  width: 100%;
  min-height: 6px;
}
.select_disabled {
  position: relative;
  z-index: 2;
  cursor: not-allowed;
}
.options-content {
  min-width: 200px;
}

.el-button--primary {
  background-color: #327bba;
  &:hover {
    background-color: #327bba;
    opacity: 0.9;
  }
}
.el-checkbox__input {
  height: 14px;
}
.control__checkbox {
  display: flex;
  align-items: center;
  margin-bottom: 0;
}
.el-checkbox__input.is-checked .el-checkbox__inner,
.el-checkbox__input.is-indeterminate .el-checkbox__inner {
  background-color: #327bba;
  border-color: #327bba;
}
.el-checkbox__inner:hover,
.el-select .el-input.is-focus .el-input__inner,
.el-select .el-input__inner:focus,
.el-checkbox__input.is-focus .el-checkbox__inner {
  border-color: #327bba;
}
.el-select-dropdown__item.selected {
  color: #327bba;
}
.slider {
  min-height: 38px;
  position: relative;
  max-width: 375px;
  width: 100%;
  margin-left: 15px;
}
.el-slider {
  width: 100%;
}
.el-slider.disabled {
  z-index: 2;
}
.colorpicker,
.el-color-picker__trigger,
.el-color-picker__mask {
  width: 100%;
}
.color-control .el-checkbox {
  margin-bottom: 5px;
}
.color-control .el-color-picker {
  height: 40px;
}
.colorpicker.disabled {
  z-index: 2;
}
#options-control .child-collapse {
  padding-left: 20px;
  .el-collapse-item__header {
    font-weight: normal;
  }
}
.options-wrapper-title {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 10px;
}
.description {
  margin: 0 0 30px;
}
</style>
